import { CSSProperties, useState } from 'react'
import styled from 'styled-components'

import { Stylable } from 'utils/types'

const Tab = styled.div<{ $isActive: boolean }>`
  flex: 1;
  text-align: center;
  padding: 16px;
  cursor: pointer;
  color: ${p => p.theme.colors.text.primary};
  border-bottom: 2px solid ${p => (p.$isActive ? p.theme.colors.text.primary : p.theme.colors.inactiveTab)};
  font-size: ${p => p.theme.typography.size.Subtitle2}px;
  font-weight: ${p => (p.$isActive ? p.theme.typography.weight.Bold : p.theme.typography.weight.Medium)};
  max-width: 350px;
  align-items: center;
  display: flex;
  justify-content: center;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    font-size: ${p => p.theme.typography.size.Caption1}px;
  }
`

const TabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const TabList = styled.div`
  display: flex;
  justify-content: center;
`

const TabPanel = styled.div`
  padding-top: 32px;
`

interface TabProps {
  label: string
  content: React.ReactNode
}

interface TabsProps extends Stylable {
  tabs: TabProps[]
  tabStyles?: CSSProperties
  tabsStyles?: CSSProperties
  tabPanelStyles?: CSSProperties
  ref?: React.Ref<HTMLDivElement>
}

export const Tabs = ({ tabs, tabStyles, tabsStyles, tabPanelStyles, ref }: TabsProps) => {
  const [activeTab, setActiveTab] = useState(0)

  return (
    <TabsContainer ref={ref}>
      <TabList role="tablist" style={tabsStyles}>
        {tabs.map((tab, index) => (
          <Tab
            style={tabStyles}
            key={index}
            role="tab"
            $isActive={activeTab === index}
            aria-selected={activeTab === index}
            aria-controls={`tabpanel-${index}`}
            id={`tab-${index}`}
            onClick={() => setActiveTab(index)}
          >
            {tab.label}
          </Tab>
        ))}
      </TabList>
      <TabPanel
        role="tabpanel"
        id={`tabpanel-${activeTab}`}
        aria-labelledby={`tab-${activeTab}`}
        style={tabPanelStyles}
      >
        {tabs[activeTab]?.content}
      </TabPanel>
    </TabsContainer>
  )
}
